var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgDownarrow = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8256 1.15237C12.6615 0.999991 12.3949 0.999991 12.2308 1.15237L6.99999 6.01904L1.75896 1.15237C1.59486 0.999991 1.3282 0.999991 1.16409 1.15237C0.99999 1.30475 0.99999 1.55237 1.16409 1.70475L6.6923 6.83809C6.77435 6.91428 6.87691 6.95237 6.98973 6.95237C7.0923 6.95237 7.20512 6.91428 7.28717 6.83809L12.8154 1.70475C12.9897 1.55237 12.9897 1.30475 12.8256 1.15237Z",
    fill: "#373737",
    stroke: "#414141",
    strokeWidth: 0.7
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDownarrow, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/downarrow.00c70b6a.svg";
export { ForwardRef as ReactComponent };